import { FC, Dispatch, useState, useEffect } from "react";
import { StopEventPropagation } from "../../../helper/ui/methods";
import { ProjectTeamInterface } from "../../../middleware/interfaces/project/project-team-interface";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";
import { UserDecisionInterface } from "../../../middleware/interfaces/user/user-decision-interface";
import { ProjectTeamEditInterface } from "../../../middleware/interfaces/project/project-team-edit-interface";

interface projectTeamDialogProps {
  user: UserInterface;
  projectTeam: ProjectTeamInterface | null | undefined;
  dispatch: Dispatch<any>;
}

const ProjectTeamDialog: FC<projectTeamDialogProps> = ({
  user,
  projectTeam,
  dispatch,
}) => {
  const [submit, setSubmit] = useState(false);
  const [editTeamMemberRoles, setEditTeamMemberRoles] =
    useState<ProjectTeamEditInterface>({
      projectTeam: {},
      type: "ProjectTeamEditInterface",
    });

  useEffect(() => {
    if (projectTeam?.projectTeam) {
      const projectTeamData = projectTeam.projectTeam.reduce(
        (
          acc: Record<string, string>,
          member: { Email: string; ProjectUserRole: string }
        ) => {
          if (member.ProjectUserRole !== "OWNER") {
            acc[member.Email] = member.ProjectUserRole;
          }
          return acc;
        },
        {}
      );
      setEditTeamMemberRoles({
        projectID: projectTeam.projectID,
        projectTeam: projectTeamData,
        type: "ProjectTeamEditInterface",
      });
    }
  }, [projectTeam]);

  useEffect(() => {
    if (submit) {
      const hasChanges = projectTeam?.projectTeam.some(
        (member: { Email: string; ProjectUserRole: string }) =>
          member.ProjectUserRole !==
          editTeamMemberRoles.projectTeam[member.Email]
      );
      if (hasChanges) {
        const decisionMessage = "Do you want to update team member roles?";

        const decision: UserDecisionInterface = {
          title: "Save role changes?",
          confirmLabel: "Save",
          message: decisionMessage,
          decisionOptions: ["EDIT_PROJECT_TEAM", "NO_ACTION"],
          result: "",
          data: editTeamMemberRoles,
          type: "UserDecisionInterface",
        };

        dispatch({ type: "CLOSE_PROJECT_TEAM" });
        dispatch({
          type: "DECISION",
          decision: decision,
        });
      } else {
        dispatch({ type: "CLOSE_PROJECT_TEAM" });
        dispatch({
          type: "RESPONSE",
          response: "No change has been made!",
        });
      }
      setSubmit(false);
    }
  }, [submit]);

  if (!projectTeam) {
    return null;
  }

  return (
    <div className="dialogCover" onClick={StopEventPropagation}>
      <div className="dialog dialogWide">
        <div className="dialogHeader">
          <div className="dialogHeading">
            <h2 className="dialogTitle">Project team</h2>
          </div>
          <span className="dialogClose" onClick={() => dispatch({ type: "CLOSE_PROJECT_TEAM" })}>
            ×
          </span>
        </div>
        <div className="dialogBody">
          <div id="projectTeamWrapper">
            <div id="projectTeamHeaderWrapper">
              <span className="projectTeamHeader">Member Email</span>
              <span className="projectTeamHeader">Access Granted By</span>
              <span className="projectTeamHeader">Member Role</span>
            </div>
            {projectTeam.projectTeam.map(
              (
                member: {
                  Email: string;
                  ProjectAccessGrantedBy: string;
                  ProjectUserRole: string;
                },
                index: number
              ) => (
                <div key={index} className="projectTeamContentWrapper">
                  <span className="projectTeamContent">{member.Email}</span>
                  <span className="projectTeamContent">
                    {member.ProjectAccessGrantedBy}
                  </span>
                  <span className="projectTeamContent">
                    {member.ProjectUserRole === "OWNER" ? (
                      member.ProjectUserRole
                    ) : (
                      <select
                        value={editTeamMemberRoles.projectTeam[member.Email]}
                        onChange={(e) => {
                          setEditTeamMemberRoles((prev) => ({
                            ...prev,
                            projectTeam: {
                              ...prev.projectTeam,
                              [member.Email]: e.target.value,
                            },
                          }));
                        }}
                        disabled={user.email === member.Email}
                      >
                        <option value="USER">USER</option>
                        <option value="ADMIN">ADMIN</option>
                        <option value="NONE">NONE</option>
                      </select>
                    )}
                  </span>
                </div>
              )
            )}
          </div>
        </div>
        <div className="dialogButtonWrapper">
          <input
            type="button"
            name="cancelProjectTeam"
            value="Cancel"
            onClick={() => dispatch({ type: "CLOSE_PROJECT_TEAM" })}
          />
          <input
            type="button"
            className="dialogPrimaryButton"
            name="submitProjectTeam"
            value="Submit"
            onClick={() => setSubmit(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectTeamDialog;
